<template>
  <component
    :is="icon"
    :size="formattedSize"
    :stroke-width="strokeWidth"
    :absolute-stroke-width="absoluteStrokeWidth"
  />
</template>

<script lang="ts" setup>
import type { LucideIcon } from 'lucide-vue-next'

const props = withDefaults(
  defineProps<{
    icon: LucideIcon
    size?: 'sm' | 'md' | 'lg' | number
    strokeWidth?: number | string
    absoluteStrokeWidth?: boolean
  }>(),
  {
    size: 'md',
    strokeWidth: 1.5,
    absoluteStrokeWidth: false,
  },
)

const formattedSize = computed(() => {
  switch (props.size) {
    case 'sm':
      return 14
    case 'md':
      return 18
    case 'lg':
      return 22
    default:
      return props.size
  }
})
</script>
